export default "__VITE_ASSET__73b43928__"